import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useMobile } from '../../../hooks/useMobile';
import Button from '../Button/Button';
import LoadingButton from '../../lowLevel/LoadingButton';

const useStyles = makeStyles((theme: any) => ({
  buttons: {
    marginTop: theme.spacing(3),
    display: 'flex',
    justifyContent: 'center',
  },
  divider: { marginLeft: theme.spacing(2), marginRight: theme.spacing(2) },
  button: {
    width: 140,
    fontSize: theme.fontSizes.onboarding,
    marginRight: theme.spacing(2),
  },
}));

//TODO: need to add to storybook
export default function NextExitButtons({
  disable = false,
  backClick = null,
  loading = false,
}) {
  const mobile = useMobile();
  const classes = useStyles({ mobile });

  return (
    <div className={classes.buttons}>
      {backClick && (
        <>
          <Button className={classes.button} onClick={backClick}>
            Back
          </Button>
          <div className={classes.divider} />
        </>
      )}
      <LoadingButton
        type={'submit'}
        color={'primary'}
        variant={'contained'}
        className={classes.button}
        disabled={disable}
        loading={loading}
        data-automation-id={'onboardingNextButton'}
      >
        Next
      </LoadingButton>
    </div>
  );
}
